import { headers } from "../utils/utils";

const useObjetivoStore = defineStore("objetivo", () => {
  // state
  const objetivo = ref({
    id: null,
    nombre: null,
    descripcion: null,
    model_id: null,
    model_type: "App\\Models\\Compra",
    activo: true,
    tipo_medidor: 1, // 1: cantidad , 2: Monto decimal
    objetivo: 0,
    insignia: null,
    model: null,
    roles: [],
  });

  const objetivos = ref([]);

  const tipo_medidor_options = ref([
    { text: "Cantidad", value: 1 },
    { text: "Monto", value: 2 },
  ]);

  const modelos = ref([
    {
      text: "Ventas",
      value: "App\\Models\\Compra",
      descripcion:
        "El Objetivo se tomará de las ventas que se realicen por parte de los perfiles",
    },
    {
      text: "Retiros",
      value: "App\\Models\\Retiro",
      descripcion:
        "El Objetivo se tomará de los retiros que realicen los usuarios",
    },
    {
      text: "Biografías",
      value: "App\\Models\\Biografia",
      descripcion:
        "El Objetivo se tomará de las biografías que completen los autores, esto es solo para autores",
    },

    {
      text: "Comisiones",
      value: "App\\Models\\Movimiento",
      descripcion:
        "El Objetivo puede medir las comisiones que se alcancen por ventas o cantidad de comisiones obtenidas",
    },

    {
      text: "Codigos de promoción",
      value: "App\\Models\\CodigosPromotor",
      descripcion: "Con este módelo puedes medir la cantidad de códigos usados",
    },
  ]);

  const getLegendModelList = (model_type) => {
    const model = modelos.value.find((m) => m.value === model_type);
    switch (model.value) {
      case "App\\Models\\Compra":
        return "Por ventas realizadas con el código de promoción del usuario.";
        break;
      case "App\\Models\\Retiro":
        return "Por retiros realizados.";
        break;

      case "App\\Models\\Biografia":
        return "Por biografías completadas.";
        break;

      case "App\\Models\\Movimiento":
        return "Por comisiones obtenidas o cantidad de movimientos por comisión.";
        break;

      case "App\\Models\\CodigosPromotor":
        return "Por códigos de promoción usados.";
        break;
    }
  };
  // mutations
  const setObjetivo = (obje) => {
    if (obje) objetivo.value = obje;
  };

  const setObjetivos = (ps) => {
    if (ps) objetivos.value = ps;
  };

  const clear = () => {
    objetivo.value = {
      id: null,
      nombre: null,
      descripcion: null,
      model_id: null,
      model_type: "App\\Models\\Compra",
      activo: true,
      tipo_medidor: 1, // 1: cantidad , 2: Monto decimal
      objetivo: 0,
      insignia: null,
      model: null,
      roles: [],
    };
  };

  // actions

  const fetch = (objetivo_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/objetivos/${objetivo_id}/fetch-data`)
        .then(({ data }) => {
          setObjetivo(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/objetivos/fetch-data`, params)
        .then(({ data }) => {
          if (data.objetivos) setObjetivos(data.objetivos);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = async (datos) => {
    try {
      let formData = new FormData();

      Object.keys(datos).forEach((key) => {
        if (key === "roles") {
          formData.append("roles[]", datos[key]);
        } else {
          formData.append(key, datos[key]);
        }
      });

      if (datos.id) {
        formData.append("_method", "PUT");
        const { data } = await axios.post(
          `/api/objetivos/${datos.id}`,
          formData,
          { headers }
        );
        if (data.result) {
          setObjetivo(data.objetivo);
        }
        return data;
      } else {
        const { data } = await axios.post(`/api/objetivos`, formData, {
          headers,
        });
        if (data.result) {
          setObjetivo(data.objetivo);
          objetivos.value.push(data.objetivo);
        }
        return data;
      }
    } catch (error) {
      throw error;
    }
  };

  const eliminar = async (objetivo_id) => {
    try {
      const { data } = await axios.delete(`/api/objetivos/${objetivo_id}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const objetivosLogradosUsuario = async (usuario_id) => {
    try {
      const { data } = await axios.get(
        `/api/objetivos/usuario/${usuario_id}/objetivos-logrados`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const cargarListadoOrdenado = async () => {
    try {
      const { data } = await axios.get(`/api/objetivos/lista-ordenada`);
      if (data.length) setObjetivos(data);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const ordenar = async (datos) => {
    try {
      const { data } = await axios.post(`/api/objetivos/ordenar`, {
        objetivos: datos,
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    objetivo,
    objetivos,
    tipo_medidor_options,
    modelos,
    setObjetivo,
    getLegendModelList,
    setObjetivos,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    cargarListadoOrdenado,
    objetivosLogradosUsuario,
    ordenar,
  };
});

export default useObjetivoStore;
